import { render, staticRenderFns } from "./EkDetails.vue?vue&type=template&id=29c2b7d9&scoped=true"
import script from "./EkDetails.vue?vue&type=script&lang=js"
export * from "./EkDetails.vue?vue&type=script&lang=js"
import style0 from "./EkDetails.vue?vue&type=style&index=0&id=29c2b7d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c2b7d9",
  null
  
)

export default component.exports